import React from "react";

const RISK_CONFIG = {
  good: { color: "#7BB32E", label: "Gut versorgt" },
  low_risk: { color: "#C77B0F", label: "Leicht trocken" },
  medium_risk: { color: "#E5A228", label: "Trockenheit" },
  high_risk: { color: "#D93025", label: "Stark trocken" },
  frost: { color: "#2569A3", label: "Frost" },
  unknown: { color: "#808080", label: "Kein Status" },
};

function mapHealthState(healthState) {
  if (healthState === null || healthState === undefined) return "unknown";

  // Numeric health_state from API (0-4)
  // 0 = good, 1 = low_risk, 2 = medium_risk / high_risk, 3 = unknown, 4 = frost
  if (typeof healthState === "number") {
    const numMap = {
      0: "good",
      1: "low_risk",
      2: "high_risk",
      3: "unknown",
      4: "frost",
    };
    return numMap[healthState] || "unknown";
  }

  // String health_state (legacy / alternative format)
  if (typeof healthState !== "string") return "unknown";
  const normalized = healthState.toLowerCase().replace(/\s+/g, "_");
  if (normalized.includes("good") || normalized.includes("gut")) return "good";
  if (normalized.includes("high") || normalized.includes("stark")) return "high_risk";
  if (normalized.includes("medium") || normalized.includes("mittel")) return "medium_risk";
  if (normalized.includes("low") || normalized.includes("leicht") || normalized.includes("dry"))
    return "low_risk";
  if (normalized.includes("frost")) return "frost";
  return "unknown";
}

export default function RiskIndicator({ healthState }) {
  const risk = mapHealthState(healthState);
  const config = RISK_CONFIG[risk];

  return (
    <div className="risk-indicator" style={{ background: config.color }}>
      <div className="risk-dot" style={{ background: "rgba(255,255,255,0.4)" }} />
      {config.label}
    </div>
  );
}
